import { useQuery } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { getPlanById } from 'api/auth.api';

export const useGetPlanById = (id, options = {}) => {
  const toast = useToast();

  return useQuery({
    queryKey: ['plan-by-id', id],
    queryFn: () => getPlanById(id),

    enabled: !!id,

    select: (res) => res?.data?.result || res?.data?.data || null,

    onError: (error) => {
      toast({
        title: 'Failed to fetch plan',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },

    ...options,
  });
};
